module.exports = __webpack_public_path__ + "static/02-def2268ffab5c296d9ce8e37acb37ce3.jpg";